<template>
  <div class="panel">
    <div
      v-for="(i, k) in Math.ceil(list.length / 4)"
      class="panel-line"
      :key="k"
      :class="{ 'pull-left': i % 2 == 0, 'pull-right': i % 2 == 1 }"
    >
      <div
        class="panel-line-item link-before"
        :data-id="i * 6 - 5"
        :class="{ 'no-line': i == 1 }"
      >
        <div class="cricle" data-antime="100"></div>
        <div class="v-bar" data-antime="300"></div>
      </div>
      <template
        v-for="(item, idx) in list.slice(
          parseInt((i - 1) * 4),
          parseInt(i * 4)
        )"
      >
        <div
          class="panel-line-item"
          :data-id="(i - 1) * 6 + 2 + idx"
          :key="idx"
          :class="{ 'no-line': (i - 1) * 4 + idx + 1 == list.length }"
        >
          <div class="infomation">
            <div class="">
              <img class="infomation-image" :src="item.image" alt="" />
            </div>
            <div class="infomation-text">
              {{ item.text }}
            </div>
          </div>
          <div class="line-dot" data-antime="200">
            <div class="dot" data-antime="300"></div>
          </div>
          <div class="step-name">{{ item.step }}</div>
        </div>
      </template>
      <div
        class="panel-line-item link-after"
        :data-id="i * 6"
        :class="{ 'no-line': i == Math.ceil(list.length / 4) }"
      >
        <div class="cricle" data-antime="100"></div>
        <div class="v-bar" data-antime="300"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "process",
  data() {
    return {
      list: [
        {
          active: false,
          icon: "",
          text: "售前咨询",
          step: "第一步",
          image: require("../../assets/indexImg/a1.png"),
        },
        {
          active: false,
          icon: "",
          text: "确认方案",
          step: "第二步",
          image: require("../../assets/indexImg/a2.png"),
        },
        {
          active: false,
          icon: "",
          text: "配置报价",
          step: "第三步",
          image: require("../../assets/indexImg/a3.png"),
        },
        {
          active: false,
          icon: "",
          text: "勘探设计",
          step: "第四步",
          image: require("../../assets/indexImg/a4.png"),
        },
        {
          active: false,
          icon: "",
          text: "按期交货",
          step: "第五步",
          image: require("../../assets/indexImg/a5.png"),
        },
        {
          active: false,
          icon: "",
          text: "安装指导",
          step: "第六步",
          image: require("../../assets/indexImg/a6.png"),
        },
        {
          active: false,
          icon: "",
          text: "验收交付",
          step: "第七步",
          image: require("../../assets/indexImg/a7.png"),
        },
        {
          active: false,
          icon: "",
          text: "售后服务",
          step: "第八步",
          image: require("../../assets/indexImg/a8.png"),
        },
      ],
    };
  },
};

let activeMaxNumber = 0;
let toNumber = 1;
let activeTimer = null;

var toAnimation = function (list, i) {
  if (list.length > 0 && i < list.length) {
    let item = $(list[i]);
    item.addClass("active");
    let nextDom = $(item).next();
    let prevDom = $(item).prev();
    if (
      nextDom &&
      nextDom.is(".step-name") &&
      prevDom &&
      prevDom.find(".infomation")
    ) {
      nextDom.addClass("active");
      prevDom.addClass("active");
    }
    activeTimer = setTimeout(() => {
      toAnimation(list, i + 1);
    }, item.data("antime"));
  } else {
    toNumber++;
    goAnimation();
  }
};

var reAnimation = function (list, i) {
  if (list.length > 0 && i >= 0) {
    let item = $(list[i]);
    item.removeClass("active");
    let nextDom = $(item).next();
    let prevDom = $(item).prev();
    if (
      nextDom &&
      nextDom.is(".step-name") &&
      prevDom &&
      prevDom.find(".infomation")
    ) {
      nextDom.removeClass("active");
      prevDom.removeClass("active");
    }
    activeTimer = setTimeout(() => {
      reAnimation(list, i - 1);
    }, item.data("antime"));
  } else {
    toNumber--;
    if (toNumber < 1) {
      toNumber = 1;
    }
    goAnimation();
  }
};

let goAnimation = function () {
  if (activeMaxNumber > 0 || toNumber > 1) {
    if (activeMaxNumber > toNumber) {
      let target = $(`.panel [data-id=${toNumber}]`);
      if (target.length) {
        let child = target.find("[data-antime]");
        toAnimation(child, 0);
      }
    }
    if (activeMaxNumber <= toNumber) {
      let target = $(`.panel [data-id=${toNumber}]`);
      if (target.length) {
        let child = target.find("[data-antime]");
        reAnimation(child, child.length);
      }
    }
  } else {
    clearTimeout(activeTimer);
  }
};

let panelItemFocus = function () {
  clearTimeout(activeTimer);
  activeMaxNumber = $(this).data("id");
  goAnimation();
};
let panelItemBlur = function () {
  clearTimeout(activeTimer);
  activeMaxNumber = 0;
  goAnimation();
};
$(document).on("mouseenter", ".panel-line-item", panelItemFocus);
$(document).on("mouseleave", ".panel-line-item", panelItemBlur);
</script>

<style scoped lang="less">
@line-height: 279px;
@text-height: 91px;
@dot-width: 25px;
@active-dot-width: 15px;
@default-line-color: #ffffff;
@active-line-color: #0fffff;
@text-color: #ffffff;

@keyframes dot-ani {
  0% {
    width: 0;
    height: 0;
  }
  30% {
    width: 12px;
    height: 12px;
  }
  100% {
    width: 25px;
    height: 25px;
  }
}

.panel {
  text-align: center;
  overflow: hidden;
  // margin-top: 60px;
  margin-top: 6vh;
  width: 100%;
  .panel-line {
    &:after,
    &::after {
      content: "";
      clear: both;
      display: block;
    }

    &.pull-right {
      .panel-line-item {
        float: left;
        &.link-before {
          .cricle {
            transform: rotate(-135deg);
            left: unset;
            right: calc(-@dot-width * 1.5 - 1px);

            &.active {
              &:after {
                transform: rotate(0deg);
              }
            }
          }

          .v-bar {
            left: unset;
            right: calc(-200% + calc(@dot-width * 0.5));
            transform: rotate(0deg);
            border-bottom: 0;
            border-top: 1px solid #000000;

            &:after {
              bottom: unset;
              top: -2px;
            }

            &.active {
              &:after {
                width: 100%;
              }
            }
          }
        }
      }
    }

    &.pull-left {
      .panel-line-item {
        float: right;

        &.link-after {
          .cricle {
            transform: rotate(-45deg);
            left: unset;
            right: calc(calc(calc(50% / 3) * 4) - calc(@dot-width * 1.5) - 1px);

            &.active {
              &:after {
                transform: rotate(0deg);
              }
            }
          }

          .v-bar {
            border: 1px solid transparent;
            border-right: 1px solid @default-line-color;
            right: calc(calc(calc(50% / 3) * 4) + calc(@dot-width / 2));
            left: unset;

            &.active {
              &:after {
                left: 1px;
              }
            }
          }
        }

        .line-dot {
          &:after {
            border-bottom: 1px solid @active-line-color;
            border-top: 0;
            right: calc(50% + calc(@dot-width / 2));
            left: unset;
            transform: rotate(180deg);
          }

          &:before {
            right: calc(50% + calc(@dot-width / 2));
            left: unset;
          }

          &.active {
            &:after {
              width: calc(100% - @dot-width);
            }
          }

          .dot {
            &.active {
              border-color: @active-line-color;

              &:after {
                width: @active-dot-width;
                height: @active-dot-width;
                animation: unset;
              }
            }
          }
        }
      }
    }

    .panel-line-item {
      width: 20%;
      height: @line-height;
      z-index: 2;

      &.no-line {
        .cricle {
          display: none;
        }

        .v-bar {
          display: none;
        }

        .line-dot {
          &:before {
            display: none;
          }

          &:after {
            display: none;
          }

          &.active {
            &:after {
              width: calc(100% - @dot-width);
            }
          }

          .dot {
            &.active {
              border-color: @active-line-color;

              &:after {
                width: @active-dot-width;
                height: @active-dot-width;
                animation: unset;
              }
            }
          }
        }
      }

      &:hover {
        .line-dot {
          .dot {
            &:after {
              animation: dot-ani 1s linear infinite;
            }
          }
        }
      }

      &.link-before {
        width: 5%;
        height: @line-height;
        position: relative;

        .cricle {
          z-index: 5;
          position: absolute;
          border: 1px solid transparent;
          border-top-color: @default-line-color;
          top: calc(@text-height - calc(@dot-width * 1.5) - 1px);
          left: calc(-@dot-width * 1.5 - 1px);
          width: calc(@dot-width * 2);
          height: calc(@dot-width * 2);
          border-radius: 50%;
          transform: rotate(135deg);
          clip: rect(0 calc(@dot-width * 2) calc(calc(@dot-width * 8) / 25) 0);

          &.active {
            &:after {
              transform: rotate(0deg);
            }
          }

          &:after {
            content: "";
            z-index: 1;
            position: absolute;
            border: 1px solid transparent;
            border-top-color: @active-line-color;
            top: -1px;
            left: -1px;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            transform: rotate(-90deg);
            transition: all 0.1s linear;
          }
        }

        .v-bar {
          position: absolute;
          width: calc(200% - @dot-width);
          height: 1px;
          border-bottom: 1px solid @default-line-color;
          top: calc(@text-height + calc(@dot-width * 0.5));
          left: calc(-200% + calc(@dot-width * 0.5));
          transform: rotate(180deg);

          &.active {
            &:after {
              width: 100%;
            }
          }

          &:after {
            content: "";
            position: absolute;
            width: 0;
            height: 1px;
            border-bottom: 1px solid @active-line-color;
            top: 0;
            left: 0;
            transition: width 0.3s linear;
          }
        }
      }

      &.link-after {
        width: 15%;
        height: @line-height;
        position: relative;
        z-index: 1;

        .cricle {
          z-index: -1;
          position: absolute;
          border: 1px solid transparent;
          border-top-color: @default-line-color;
          top: calc(@text-height + calc(@dot-width / 2));
          left: calc(calc(calc(50% / 3) * 4) - calc(@dot-width * 1.5) - 0px);
          width: calc(@dot-width * 2);
          height: calc(@dot-width * 2);
          border-radius: 50%;
          transform: rotate(45deg);
          clip: rect(0 calc(@dot-width * 2) calc(calc(@dot-width * 8) / 25) 0);

          &:after {
            content: "";
            z-index: 1;
            position: absolute;
            border: 1px solid transparent;
            border-top-color: @active-line-color;
            top: -1px;
            left: -1px;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            transform: rotate(-90deg);
            transition: all 0.1s linear;
          }

          &.active {
            &:after {
              transform: rotate(0deg);
            }
          }
        }

        .v-bar {
          z-index: -1;
          position: absolute;
          border-left: 1px solid @default-line-color;
          width: 1px;
          height: calc(@line-height - calc(@dot-width * 2));
          top: calc(@text-height + calc(@dot-width * 1.5));
          left: calc(calc(calc(50% / 3) * 4) + calc(@dot-width / 2));

          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: -1px;
            z-index: 1;
            width: 1px;
            height: 0;
            border-left: 1px solid @active-line-color;
            transition: height 0.3s linear;
          }

          &.active {
            &:after {
              height: 100%;
            }
          }
        }
      }

      .infomation {
        color: @text-color;
        height: @text-height;
        .infomation-image {
          width: 49px;
          height: 49px;
        }

        .infomation-text {
          font-size: 17px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 29px;
        }
        &.active {
          color: @active-line-color;
        }
      }
      .step-name {
        color: @text-color;
        font-size: 17px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 29px;
        &.active {
          color: @active-line-color;
        }
      }

      .line-dot {
        margin-bottom: 10px;
        position: relative;
        z-index: 0;
        height: @dot-width;
        width: 100%;

        &:after {
          content: "";
          position: absolute;
          width: 0;
          height: 1px;
          border-top: 1px solid @active-line-color;
          top: 50%;
          left: calc(50% + calc(@dot-width / 2));
          z-index: 2;
          transition: width 0.5s linear;
        }

        &:before {
          content: "";
          position: absolute;
          width: calc(100% - @dot-width);
          height: 1px;
          border-top: 1px solid @default-line-color;
          top: 50%;
          left: calc(50% + calc(@dot-width / 2));
          z-index: 1;
        }

        .dot {
          position: absolute;
          z-index: 4;
          background-color: #ffffff;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          margin: 0 auto;
          width: @dot-width;
          height: @dot-width;
          border-radius: @dot-width;
          border: 1px solid @default-line-color;
          display: flex;
          justify-content: center;
          align-items: center;

          &:after {
            content: "";
            display: flex;
            background-color: @active-line-color;
            width: 0;
            height: 0;
            border-radius: 25px;
            transition: all 500ms linear;
          }
        }

        &.active {
          &:after {
            width: calc(100% - @dot-width);
          }

          .dot {
            border-color: @active-line-color;

            &:after {
              width: @active-dot-width;
              height: @active-dot-width;
              animation: unset;
            }
          }
        }
      }
    }
  }
}
</style>